import { render, staticRenderFns } from "./KitPercentageForm.vue?vue&type=template&id=01fb256d&scoped=true&"
import script from "./KitPercentageForm.vue?vue&type=script&lang=js&"
export * from "./KitPercentageForm.vue?vue&type=script&lang=js&"
import style0 from "./KitPercentageForm.vue?vue&type=style&index=0&id=01fb256d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fb256d",
  null
  
)

export default component.exports